export const PILLS_CONTAINER_ID = 'filter-pills-container'
